import { z } from 'zod';
import LangEnum from '../../lang/LangEnum';
import { TranslateType } from '../translation/translationContext.types';

export const buildPosFormSchema = (translate: TranslateType) =>
  z.object({
    pointOfSale: z
      .object({
        name: z.string(),
        id: z.string().nullable().optional(),
      })
      .nullable()
      .refine((value) => value !== null, translate(LangEnum.GLOBAL_REQUIRED)),
  });

export type PosFormValues = z.input<ReturnType<typeof buildPosFormSchema>>;
